import React, { useState, useContext, useEffect } from "react";
import { useForm, useFieldArray, Controller } from "react-hook-form";
import { updateBusinessMonitoringInfo } from "../UpdateMonitoringInfo";
import { months } from "../../../../util/CommonLists";
import { PATTERNS } from "../../../../util/patterns";
import { emailMasking } from "../../../../util/CommonReadonlyMasking";
import { useDispatch, useSelector } from "react-redux";
import { getFlowByName } from "../../../../config/FlowName";
import * as NextStepFlowAction from "../../../../store/nextStepFlowService/actions";
import { ApplicationState } from "../../../../store";
import { Notification } from "../../../common/Notification";
import { CommonContext } from "../../../../CommonContextProvider";
import { formatEINEditView } from "../../../../util/common";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import { isValidPhoneNo } from "../../../../util/phoneNumberValidationUtil";
import { useTranslation } from "react-i18next";

interface IProps {
    refreshDataCallback(): void;
    setStatus: any;
    status: boolean;
    formData: any;
    setFormData: any;
    addressInfo: any;
}

const BusinessInfoForm = ({ refreshDataCallback, addressInfo, setStatus, formData }: IProps) => {
    const [loading, setLoading] = useState(false);
    const [visibleEmail, setVisisbleEmail]: any = useState([]);
    const dispatch = useDispatch();
    const { updateBusinessAditionalInformationDshboardGetStartedStatus }: any = useContext(CommonContext);
    const monitoringInfoFlow = useSelector((state: ApplicationState) => getFlowByName(state, "ADD-YOUR-ADDITIONAL-INFORMATION"));
    const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));
    const businessProfileStatus = useSelector(
        (state: ApplicationState) =>
            state.loggedInUser &&
            state.loggedInUser.userServiceDetails?.businessProfileStatus?.filter((obj: any) => {
                return obj.provider;
            })
    );
    const creditProvider = businessProfileStatus != null && businessProfileStatus.length > 0 ? businessProfileStatus[0].provider : "";
    const [errorMsg, seterrorMsg] = useState("");
    const [hasError, setHasError] = useState(false);
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const { t: tLang } = useTranslation();

    /**Validation with react-hook-form ***/
    const { register, handleSubmit, errors, control, watch, getValues } = useForm({
        mode: "onBlur",
        defaultValues: {
            birthDay: formData["date-of-birth"] ? formData["date-of-birth"].split("/")[1] : "",
            birthMonth: formData["date-of-birth"] ? months[Number(formData["date-of-birth"].split("/")[0]) - 1] : "",
            birthYear: formData["date-of-birth"] ? formData["date-of-birth"].split("/")[2] : "",
            emails: formData.emails ? formData.emails : [{ email: "" }],
            firstName: formData.firstName,
            lastName: formData.lastName,
            middleName: formData.middleName,
            phone: formData.phone ? formData.phone : [{ phone: "" }],
            securityNumber: formData.securityNumber ? `XXX-XX-${formData.securityNumber.substr(formData.securityNumber.length - 4)}` : "",
            internationalSecurityNumber: formData.internationalSecurityNumber["sin"]
                ? `XXX-XX-${formData.internationalSecurityNumber["sin"].substr(formData.internationalSecurityNumber["sin"].length - 4)}`
                : "",
            nationalIdentificationNumber: formData.nationalIdentificationNumber["nid"] ? `XXX XXX ${formData.nationalIdentificationNumber["nid"].substr(6)}` : "",
            businessCreditSafeNumber: formData.businessCreditSafeNumber,
            businessDUNSNumber: formData.businessDUNSNumber,
            businessFaxNumber: formData.businessFaxNumber,
            businessName: formData.businessName,
            companyDomain: formData.companyDomain,
            businessEINNumber: formData.businessEINNumber ? formatEINEditView(formData.businessEINNumber) : "",
            businessStateRegistryNumber: formData.businessStateRegistryNumber,
        },
    });

    const emailHandler = useFieldArray({
        control,
        name: "emails",
    });

    useEffect(() => {
        disableFlag();
    }, []);

    const disableFlag = () => {
        setTimeout(() => {
            const elements = document.getElementsByClassName("PhoneInputCountry");

            if (elements && elements.length > 0) {
                try {
                    for (const el of elements) {
                        const childs = el.children;
                        if (childs[0].nodeName === "SELECT") {
                            const selectEl = childs[0] as HTMLSelectElement;
                            selectEl.disabled = true;
                        }
                    }
                } catch {}
            }
            const selectElement = document.getElementsByClassName("PhoneInputCountrySelect");
            if (selectElement && selectElement.length > 0) {
                for (const el of selectElement) {
                    if (el.tagName.toLowerCase() === "select") {
                        el.setAttribute("aria-required", "true");
                    }
                }
            }
        }, 500);
    };

    const toggleEmailVisibility = (item: any) => {
        if (visibleEmail.length > 0) {
            const index = visibleEmail.findIndex((element: any) => element.email === item.email);
            if (index >= 0) {
                visibleEmail.splice(index, 1);
                setVisisbleEmail([...visibleEmail]);
            } else {
                setVisisbleEmail([...visibleEmail, item]);
            }
        } else {
            setVisisbleEmail([...visibleEmail, item]);
        }
    };

    const phoneHandler = useFieldArray({
        control,
        name: "phone",
    });

    /***Handle submit action ***/
    const onSubmit = (data: any) => {
        data.companyDomain = formData.companyDomain;
        data.businessStateRegistryNumber = formData.businessStateRegistryNumber;
        if (data.businessEINNumber) {
            data.businessEINNumber = data.businessEINNumber.replace("-", "");
        }

        setLoading(true);
        setHasError(false);

        addressInfo.country = addressInfo["address-country"];
        updateBusinessMonitoringInfo(data, addressInfo, formData)
            .then((data: any) => {
                setLoading(false);
                if (data.isSuccess) {
                    if (monitoringInfoFlow && monitoringInfoFlow.flowStepStatus !== "COMPLETED") {
                        completeGetStartedItem(monitoringInfoFlow.flowStepId, monitoringInfoFlow.flowName ? monitoringInfoFlow.flowName : " ");
                    }
                    updateBusinessAditionalInformationDshboardGetStartedStatus();
                    refreshDataCallback();
                    setStatus(false);
                } else if (data.hasError && data.errors.length > 0) {
                    seterrorMsg(data.errors.join(", "));
                    setHasError(true);
                } else {
                    seterrorMsg("Unknown Error");
                    setHasError(true);
                }
            })
            .catch(function (error) {
                setLoading(false);
                Notification({
                    type: "error",
                    title: "Error",
                    message: error,
                    duration: 0,
                });
            });
    };

    let EINFieldPressedKey: number;

    const updatEINFieldPressedKey = (e: any) => {
        EINFieldPressedKey = e.keyCode;
    };

    function onEINChangeHandler(event: any) {
        if (event.target.value.length === 2 && EINFieldPressedKey !== 8 && EINFieldPressedKey !== 46) {
            event.target.value = event.target.value + "-";
        }
    }

    return (
        <div id="monitored-info-business-information-form" className={`${loading && "loading"}`}>
            <form onSubmit={handleSubmit(onSubmit)} id="monitored-info-business-information-form-container">
                <div className={`form-row inline row ${errors["businessName"] && errors["businessName"] && "status-error"}`}>
                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                        <label htmlFor="label-business-name">
                            {tLang("identityVault.monitoredInformation.businessInfoWidget.label.businessName")}
                            <span className="required" title="Mandatory">
                                *
                            </span>
                        </label>
                    </div>
                    <div role="alert" className="form-input col-xs-12 col-sm-6 col-no-gutter">
                        <input
                            aria-required="true"
                            type="text"
                            name="businessName"
                            className="inputbox"
                            id="label-business-name"
                            placeholder={tLang("identityVault.monitoredInformation.businessInfoWidget.placeholder.businessName")}
                            ref={register({
                                required: true,
                                pattern: /^[a-zA-Z0-9-',.&()\s]+$/,
                            })}
                        />
                        {!!errors["businessName"] && !!errors["businessName"] && errors["businessName"]!.type === "required" && (
                            <span className="form-error">
                                {tLang("identityVault.monitoredInformation.businessInfoWidget.validationMessage.businessName.required")}
                            </span>
                        )}
                        {!!errors["businessName"] && !!errors["businessName"] && errors["businessName"]!.type === "pattern" && (
                            <span className="form-error">
                                {tLang("identityVault.monitoredInformation.businessInfoWidget.validationMessage.businessName.invalidFormat")}
                            </span>
                        )}
                    </div>
                </div>

                {emailHandler.fields.map((item, index) => {
                    return (
                        <div className={`form-row inline row ${errors["emails"] && errors["emails"][index] && "status-error"}`} key={item.id}>
                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                {index === 0 ? (
                                    <label htmlFor={`label-email-${index + 1}`}>
                                        {tLang("identityVault.monitoredInformation.businessInfoWidget.label.email")}
                                        <span className="required" title="Mandatory">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                ) : <label htmlFor={`label-email-${index + 1}`} className="hide-label" >
                                        {tLang("identityVault.monitoredInformation.businessInfoWidget.label.email")}{`${' '.repeat(index + 1)}`}
                                </label>}
                            </div>
                            <div role="alert" className="form-input col-xs-12 col-sm-6 col-no-gutter">
                                <input
                                    aria-required="true"
                                    type="text"
                                    className={
                                        formData.emails.findIndex((element: any) => element.email === item.email) >= 0 &&
                                            visibleEmail.findIndex((element: any) => element.email === item.email) < 0 &&
                                            item.email !== ""
                                            ? "inputbox hide-input"
                                            : "inputbox"
                                    }
                                    id={`label-email-${index + 1}`}
                                    placeholder={tLang("identityVault.monitoredInformation.businessInfoWidget.placeholder.email")}
                                    name={`emails[${index}].email`}
                                    defaultValue={`${item!.email}`}
                                    maxLength={PATTERNS.EMAIL.maxLength}
                                    ref={register({
                                        required: true,
                                        pattern: PATTERNS.EMAIL.pattern,
                                        validate: (): boolean | string => {
                                            const emails = getValues().emails;
                                            const duplicate = emails.reduce((p: any, c: any) => {
                                                if (c.email === emails[index].email) p++;
                                                return p;
                                            }, 0);
                                            if (duplicate > 1) {
                                                return false;
                                            }
                                            return true;
                                        },
                                    })}
                                />
                                <span
                                    hidden={
                                        formData.emails.findIndex((element: any) => element.email === item.email) < 0 ||
                                        item.email === "" ||
                                        visibleEmail.findIndex((element: any) => element.email === item.email) >= 0
                                    }
                                    style={{ marginTop: "10px " }}
                                >
                                    <p>{emailMasking(item.email)}</p>
                                </span>
                                <div className="form-input-button">
                                    {item.email !== "" && (
                                        <button
                                            type="button"
                                            className="btn-default btn-icon-only btn-no-padding"
                                            onClick={() => {
                                                toggleEmailVisibility(item);
                                            }}
                                            title={
                                                visibleEmail.findIndex((element: any) => element.email === item.email) < 0
                                                    ? tLang("identityVault.monitoredInformation.businessInfoWidget.showEmailToolTip")
                                                    : tLang("identityVault.monitoredInformation.businessInfoWidget.hideEmailToolTip")
                                            }
                                        >
                                            <span className="btn-icon">
                                                <em
                                                    className={`las ${
                                                        visibleEmail.findIndex((element: any) => element.email === item.email) < 0 ? "la-eye" : "la-eye-slash"
                                                    }`}
                                                ></em>
                                            </span>
                                            <span className="btn-text">Show / Hide Email Text</span>
                                        </button>
                                    )}
                                    {emailHandler.fields && emailHandler.fields.length > 1 && (
                                        <button
                                            type="button"
                                            className="btn-default btn-icon-only btn-no-padding"
                                            style={{
                                                marginTop: formData.emails.findIndex((element: any) => element.email === item.email) >= 0 && item.email ? -10 : 0,
                                            }}
                                            onClick={() => {
                                                emailHandler.remove(index);
                                                window.addToDataLayer({ event: "Remove Alternate Email" });
                                            }}
                                        >
                                            <span className="btn-icon">
                                                <em className="las la-trash-alt"></em>
                                            </span>
                                            <span className="btn-text">Remove Alternate Email</span>
                                        </button>
                                    )}
                                </div>
                                {!!errors["emails"] && !!errors["emails"][index] && errors["emails"][index]!.email!.type === "required" && (
                                    <span className="form-error">
                                        {tLang("identityVault.monitoredInformation.businessInfoWidget.validationMessage.email.required")}
                                    </span>
                                )}
                                {!!errors["emails"] && !!errors["emails"][index] && errors["emails"][index]!.email!.type === "pattern" && (
                                    <span className="form-error">
                                        {tLang("identityVault.monitoredInformation.businessInfoWidget.validationMessage.email.invalidFormat")}
                                    </span>
                                )}
                                {!!errors["emails"] && !!errors["emails"][index] && errors["emails"][index]!.email!.type === "validate" && (
                                    <span className="form-error">
                                        {tLang("identityVault.monitoredInformation.businessInfoWidget.validationMessage.email.duplicate")}
                                    </span>
                                )}
                            </div>
                        </div>
                    );
                })}

                {emailHandler.fields && emailHandler.fields.length < 1 && (
                    <div className="form-row inline no-margin row" aria-labelledby="label-full-email" role="group">
                        <div className="group-label col-xs-12 col-sm-4 col-no-gutter" id="label-full-email">
                            <label htmlFor="label-full-email">
                                {tLang("identityVault.monitoredInformation.businessInfoWidget.label.email")}
                                <span className="required" title="Mandatory">
                                    {" "}
                                    *
                                </span>
                            </label>
                        </div>
                        <div className="group-rows col-xs-12 col-sm-6 col-no-gutter">
                            <div className="row ">
                                <button
                                    type="button"
                                    className="btn-default btn-link btn-no-padding"
                                    onClick={() => {
                                        window.addToDataLayer({ event: "Add Email Address" });
                                        emailHandler.append({
                                            email: "",
                                        });
                                    }}
                                >
                                    <span className="btn-icon">
                                        <em className="las la-plus"></em>
                                    </span>
                                    <span className="btn-text">{tLang("identityVault.monitoredInformation.businessInfoWidget.addEmailLinkText")}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {emailHandler.fields.length > 0 && emailHandler.fields.length < 10 && (
                    <div className="form-row row">
                        <div className="col-xs-12 col-sm-8 col-no-gutter col-sm-offset-4">
                            <button
                                type="button"
                                className="btn-default btn-link btn-no-padding"
                                onClick={() => {
                                    window.addToDataLayer({ event: "Add Email Address" });
                                    emailHandler.append({
                                        email: "",
                                    });
                                }}
                            >
                                <span className="btn-icon">
                                    <em className="las la-plus"></em>
                                </span>
                                <span className="btn-text">{tLang("identityVault.monitoredInformation.businessInfoWidget.addEmailLinkText")}</span>
                            </button>
                        </div>
                    </div>
                )}

                <br />

                {phoneHandler.fields.map((item, index) => {
                    return (
                        <div key={item.id} className="form-row inline no-margin row" aria-labelledby={`label-full-phone-${index + 1}`} role="group">
                            <div className="group-label col-xs-12 col-sm-4 col-no-gutter" id={`label-full-phone-${index + 1}`}>
                                {index === 0 ? (
                                    <label htmlFor={`label-phone-number-${index + 1}`}>
                                        {tLang("identityVault.monitoredInformation.businessInfoWidget.label.phone")}
                                        <span className="required" title="Mandatory">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                ) : <label htmlFor={`label-phone-number-${index + 1}`} className="hide-label" >
                                    {tLang("identityVault.monitoredInformation.personalInfoWidget.label.phone")}+{`${index + 1}`}
                                </label>
                            }

                            </div>

                            <div className="group-rows col-xs-12 col-sm-6 col-no-gutter">
                                <div className="row ">
                                    <div className="col-xs-12 col-no-gutter">
                                        <div
                                            className={`form-row inline row ${errors["phone"] && errors["phone"][index] && "status-error"} && 'status-error'} ${
                                                errors["phone"] &&
                                                errors["phone"][index] &&
                                                watch(`phone[${index}].phone`) &&
                                                !parsePhoneNumber(watch(`phone[${index}].phone`))
                                                    ? "country-error"
                                                    : ""
                                            }`}
                                        >
                                            <div className="form-label sr-only col-xs-12  col-no-gutter">
                                                <label htmlFor={`label-phone-number${index + 1}`}>
                                                    {tLang("identityVault.monitoredInformation.businessInfoWidget.label.phone")}
                                                </label>
                                            </div>
                                            <div role="alert" className="form-input col-xs-12  col-no-gutter">
                                                <Controller
                                                    aria-required="true"
                                                    name={`phone[${index}].phone`}
                                                    control={control}
                                                    defaultValue={item.phone ? item.phone : ""}
                                                    className="inputbox"
                                                    rules={{
                                                        required: true,
                                                        validate: (value): boolean | string => {
                                                            const phone = getValues().phone;
                                                            const duplicate = phone.reduce((p: any, c: any) => {
                                                                if (c.phone === phone[index].phone) p++;
                                                                return p;
                                                            }, 0);
                                                            if (duplicate > 1) {
                                                                return tLang(
                                                                    "identityVault.monitoredInformation.businessInfoWidget.validationMessage.phone.duplicate"
                                                                ) as any;
                                                            } else {
                                                                return value
                                                                    ? isValidPhoneNo(accountInfo && accountInfo.country ? accountInfo.country : "US", value)
                                                                    : false;
                                                            }
                                                        },
                                                    }}
                                                    render={({ onChange, value }) => (
                                                        <PhoneInput
                                                            aria-required="true"
                                                            value={value}
                                                            onChange={onChange}
                                                            international={false}
                                                            addInternationalOption={false}
                                                            defaultCountry={accountInfo && accountInfo.country ? accountInfo.country : "US"}
                                                            countries={[accountInfo && accountInfo.country ? accountInfo.country : "US"]}
                                                            id={`label-phone-number-${index + 1}`}
                                                            placeholder={tLang("identityVault.monitoredInformation.businessInfoWidget.placeholder.phone")}
                                                            maxLength={15}
                                                            minLength={10}
                                                        />
                                                    )}
                                                />
                                                {!!errors["phone"] && !!errors["phone"][index] && errors["phone"][index]!.phone!.type === "required" && (
                                                    <span className="form-error">
                                                        {tLang("identityVault.monitoredInformation.businessInfoWidget.validationMessage.phone.required")}
                                                    </span>
                                                )}
                                                {!!errors["phone"] && !!errors["phone"][index] && errors["phone"][index]!.phone!.type === "validate" && (
                                                    <span className="form-error">
                                                        {errors["phone"][index]!.phone!.message !== ""
                                                            ? errors["phone"][index]!.phone!.message
                                                            : tLang("identityVault.monitoredInformation.businessInfoWidget.validationMessage.phone.invalidFormat")}
                                                    </span>
                                                )}
                                                {!!errors["phone"] && !!errors["phone"][index] && errors["phone"][index]!.phone!.type === "minLength" && (
                                                    <span className="form-error">Invalid format. Phone Number must be 10 digits in length.</span>
                                                )}
                                                {!!errors["phone"] && !!errors["phone"][index] && errors["phone"][index]!.phone!.type === "maxLength" && (
                                                    <span className="form-error">Invalid format. Phone Number must be 10 digits in length.</span>
                                                )}

                                                <div className="form-input-button">
                                                    {phoneHandler.fields && phoneHandler.fields.length > 1 && (
                                                        <button
                                                            type="button"
                                                            className="btn-default btn-icon-only btn-no-padding"
                                                            onClick={() => {
                                                                phoneHandler.remove(index);
                                                                window.addToDataLayer({ event: "Remove Alternate Phone" });
                                                            }}
                                                        >
                                                            <span className="btn-icon">
                                                                <em className="las la-trash-alt"></em>
                                                            </span>
                                                            <span className="btn-text">Remove Alternate Phone</span>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}

                {phoneHandler.fields && phoneHandler.fields.length < 1 && (
                    <div className="form-row inline no-margin row" aria-labelledby="label-full-phone" role="group">
                        <div className="group-label col-xs-12 col-sm-4 col-no-gutter" id="label-full-phone">
                            <label htmlFor="label-phone-number">
                                {tLang("identityVault.monitoredInformation.businessInfoWidget.label.phone")}
                                <span className="required" title="Mandatory">
                                    {" "}
                                    *
                                </span>
                            </label>
                        </div>
                        <div className="group-rows col-xs-12 col-sm-6 col-no-gutter">
                            <div className="row ">
                                <button
                                    type="button"
                                    className="btn-default btn-link btn-no-padding"
                                    onClick={() => {
                                        window.addToDataLayer({ event: "Add Phone Number" });
                                        phoneHandler.append({ code: +1, phone: "" });
                                        disableFlag();
                                    }}
                                >
                                    <span className="btn-icon">
                                        <em className="las la-plus"></em>
                                    </span>
                                    <span className="btn-text">{tLang("identityVault.monitoredInformation.businessInfoWidget.addPhoneLinkText")}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {phoneHandler.fields.length > 0 && phoneHandler.fields.length < 10 && (
                    <div className="form-row row">
                        <div className="col-xs-12 col-sm-8 col-no-gutter col-sm-offset-4">
                            <button
                                type="button"
                                className="btn-default btn-link btn-no-padding"
                                onClick={() => {
                                    window.addToDataLayer({ event: "Add Phone Number" });
                                    phoneHandler.append({ code: +1, phone: "" });
                                    disableFlag();
                                }}
                            >
                                <span className="btn-icon">
                                    <em className="las la-plus"></em>
                                </span>
                                <span className="btn-text">{tLang("identityVault.monitoredInformation.businessInfoWidget.addPhoneLinkText")}</span>
                            </button>
                        </div>
                    </div>
                )}
                <br />
                {creditProvider === "CREDITSAFE" && (
                    <div className={`form-row inline row ${errors["businessEINNumber"] && errors["businessEINNumber"] && "status-error"}`}>
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="label-business-ein">{tLang("identityVault.monitoredInformation.businessInfoWidget.label.ein")}</label>
                        </div>
                        <div role="alert" className="form-input col-xs-12 col-sm-6 col-no-gutter">
                            <input
                                aria-required="true"
                                type="text"
                                name="businessEINNumber"
                                className="inputbox"
                                id="label-business-ein"
                                placeholder={tLang("identityVault.monitoredInformation.businessInfoWidget.placeholder.ein")}
                                onChange={onEINChangeHandler}
                                onKeyDown={updatEINFieldPressedKey}
                                ref={register({
                                    pattern: PATTERNS.EIN.pattern,
                                })}
                                maxLength={10}
                            />
                            {!!errors["businessEINNumber"] && !!errors["businessEINNumber"] && errors["businessEINNumber"]!.type === "pattern" && (
                                <span className="form-error">
                                    {tLang("identityVault.monitoredInformation.businessInfoWidget.validationMessage.ein.invalidFormat")}
                                </span>
                            )}
                        </div>
                    </div>
                )}
                <div className="margin-vertical-l"></div>
                {hasError && (
                    <div className="form-row inline row">
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter"></div>
                        <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                            <p className="form-error">{errorMsg}</p>
                        </div>
                    </div>
                )}
                <div className="margin-vertical-l"></div>
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <ul className="list-inline list-reset">
                            <li>
                                <button
                                    type="button"
                                    className="btn-default btn-link btn-no-padding btn-no-border btn-min-width"
                                    onClick={() => {
                                        setStatus(false);
                                        window.addToDataLayer({ event: "Cancel Editing Business Information" });
                                    }}
                                >
                                    <span className="btn-text">{tLang("identityVault.monitoredInformation.businessInfoWidget.cancelFormButtonText")}</span>
                                </button>
                            </li>
                            <li className="margin-left-s">
                                <button
                                    type="submit"
                                    className="btn-default btn-primary btn-min-width"
                                    onClick={() => window.addToDataLayer({ event: "Save Edited Business Information" })}
                                >
                                    <span className="btn-text">{tLang("identityVault.monitoredInformation.businessInfoWidget.saveButtonText")}</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default BusinessInfoForm;
